export function notEmpty(value) {
    if (value === null || value === undefined)
        return false;
    const testDummy = value;
    return true;
}
//# sourceMappingURL=functions.js.map